export default {
  default_program_name: 'Beloningsclub',
  message:
    'Word lid van <highlight>{{name}}</highlight> — verdien {{reward}} per {{spend}} besteed & ontgrendel gratis menu-items!',
  buttons: {
    join_now: 'Word nu lid',
  },
};
